// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"5000d98c","453":"79d3242c","746":"58e9a571"}[chunkId] + ".chunk.js";
};